import {makeAutoObservable} from 'mobx';

export enum Size {
    S = 0.25,
    M = 0.375,
    L = 0.5,
}

export enum Font {
    Roboto = 0,
    Noto = 1,
}

export type EPLine = {
    text: string;
    size: Size;
    bold: boolean;
    italic: boolean;
};

class EngravedPlateExtendedStore {
    public lines: EPLine[] = [];
    public fontFamily: string;

    constructor() {
        makeAutoObservable(this);
    }
}

export const engravedPlateExtendedStore = new EngravedPlateExtendedStore();
